import tw, { styled } from 'twin.macro';

export const StyledTitle = styled.strong`
  ${tw`font-inter font-semi-bold`}
  ${tw`text-primary-p1 text-tag-s`}
  ${tw`block`}
  ${tw`mb-[18px]`}
`;

export const StyledList = styled.ul`
  ${tw`list-none p-0 m-0`}
`;

export const StyledListItem = styled.li`
  ${tw`mb-1 last:mb-0 lg:leading-5`}
`;
